import type { PendingMutation } from './db';
export function saveFeedback(state?: PendingMutation['state']): string {
  if (!state) return 'บันทึกถึงเซิร์ฟเวอร์แล้ว';
  if (state === 'conflict') return 'เก็บในเครื่องแล้ว · ข้อมูลชนกัน กรุณากดตรวจสอบในสถานะการซิงก์';
  if (state === 'failed') return 'เก็บในเครื่องแล้ว · ส่งไม่สำเร็จ กดลองใหม่ในสถานะการซิงก์';
  return 'เก็บในเครื่องแล้ว · รอส่งถึงเซิร์ฟเวอร์';
}
